import React from 'react'
import style from './style.module.css'
export default props => (
    <div>
        <div style={{
            width:'100%',
            float: 'left',
            textAlign: 'center',
            ...props.style
        }}>
            <svg className={style.progress} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width={props.size || '40px'} height={props.size || '40px'} viewBox="0 0 50 50" style={{enableBackground: 'new 0 0 50 50'}} xmlSpace="preserve">
                <path fill={props.color || '#ff5500'} d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                </path>
            </svg>

        </div>

    </div>
)


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Loading/index.js